import roles from '@/constant/roles.config';
import { forEach, isEmpty } from 'lodash';
import moment from 'moment';
import { Bounce, toast } from 'react-toastify';
import { toExcel } from 'to-excel';


export const showSuccessMessage = (msg, position = "top-right") => {
    return <>
        {
            toast.success(msg, {
                position: position,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "light",
                transition: Bounce
            })
        }
    </>
}

export const showErrorMessage = (msg, position = "top-right") => {
    return <>
        {
            toast.error(msg, {
                position: position,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            })
        }
    </>
}

export const setAuthHeaders = () => {

    const token = localStorage.getItem('token');
    return {
        headers: {
            "Accept": "application/json",
            'Authorization': 'Bearer ' + token
        }
    }
}

export const getRandomInteger = (min, max) => {
    min = Math.ceil(min)
    max = Math.floor(max)

    return Math.floor(Math.random() * (max - min)) + min
}

export const convertUTCToTzDate = (utcDate, timezn = "Asia/Kolkata", format = "YYYY-MM-DD H:mm:ss A") => {

    let dt = new Date(utcDate).toLocaleString("en-US", { timeZone: timezn });
    return moment(dt).format(format);
}

export const downloadExcel = (headers, data, filename) => {
    toExcel.exportXLS(headers, data, filename);
}

export const webSiteURL = (website) => {
    if (website) {
        return website && isEmpty(website) ? "-" :
            website && !isEmpty(website) && (website.startsWith("http://") || website.startsWith("https://"))
                ? <a href={website} target='_blank' rel="noreferrer">{website}</a>
                : <a href={`https://${website}`} target='_blank' rel="noreferrer">{website}</a>
    } else {
        return "-";
    }
}

export const istTODate = (dateAndTimeIST) => {
    let dateStr = String(dateAndTimeIST);
    let dateOnly = dateStr.split(' ').slice(1, 4).join(' ');
    let formatted = new Date(dateOnly + ' UTC');
    let result = formatted.toISOString().split('T')[0];
    return result;

}

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const capitalizeWords = (str = "") =>
    str
        .split(" ")
        .map((word) => capitalize(word))
        .join(" ");


export const buildPath = (route, params = {}) => {
    let url = route.path;  // accept the full route object
    forEach(params, (value, key) => {
        url = url.replace(`:${key}`, value);
    });
    return url;
};

export const getOS = async () => {
    if (navigator.userAgentData) {
        try {
            const ua = await navigator.userAgentData.getHighEntropyValues(['platform', 'platformVersion']);
            return {
                platform: ua.platform?.toLowerCase() || 'unknown-os',
                platformVersion: ua.platformVersion || 'Unknown'
            };
        } catch (error) {
            console.error("Error getting high entropy values:", error);
        }
    }

    const ua = navigator.userAgent.toLowerCase();
    let platform = 'unknown-os';
    if (ua.includes('win')) platform = 'windows';
    else if (ua.includes('mac')) platform = 'mac';
    else if (ua.includes('linux')) platform = 'linux';
    else if (ua.includes('android')) platform = 'android';
    else if (/iphone|ipad|ipod/.test(ua)) platform = 'ios';

    return { platform, platformVersion: 'Unknown' };
};

export const getBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';
    let browserVersion = 'Unknown';

    if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
        browser = 'opera';
        const match = userAgent.match(/OPR\/([\d.]+)/);
        browserVersion = match ? match[1] : 'Unknown';
    }
    else if (userAgent.includes('Edg')) {
        browser = 'edge';
        const match = userAgent.match(/Edg\/([\d.]+)/);
        browserVersion = match ? match[1] : 'Unknown';
    }
    else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
        browser = 'chrome';
        const match = userAgent.match(/Chrome\/([\d.]+)/);
        browserVersion = match ? match[1] : 'Unknown';
    }
    else if (userAgent.includes('Safari')) {
        browser = 'safari';
        const match = userAgent.match(/Version\/([\d.]+)/);
        browserVersion = match ? match[1] : 'Unknown';
    }
    else if (userAgent.includes('Firefox')) {
        browser = 'firefox';
        const match = userAgent.match(/Firefox\/([\d.]+)/);
        browserVersion = match ? match[1] : 'Unknown';
    }
    else if (userAgent.includes('Trident') || userAgent.includes('MSIE')) {
        browser = 'ie';
        const msieMatch = userAgent.match(/MSIE ([\d.]+)/);
        const tridentMatch = userAgent.match(/rv:([\d.]+)/);
        browserVersion = msieMatch ? msieMatch[1] : (tridentMatch ? tridentMatch[1] : 'Unknown');
    } else {
        browser = 'unknown-browser';
        browserVersion = 'Unknown';
    }

    return { browser, browserVersion };
};

export const getPrefix = (user) => {

    if (user) {
        switch (user.role_slug.slug) {
            case "SUP_ADM":
                return roles.SUPER_ADMIN.prefix;
            case "ADMIN":
                return roles.ADMIN.prefix;
            case "PRE_KYC":
                return roles.PRE_KYC.prefix;
            case "DEMO":
                return roles.DEMO.prefix;
            case "VIEWER":
                return roles.VIEWER.prefix;
            case "END_USER":
                return roles.END_USER.prefix;
            case "OPERATION_USER":
                return roles.OPERATION_USER.prefix;
            case "INQ_MANAGER":
                return roles.INQ_MANAGER.prefix;
            default:
                return roles.SUPER_ADMIN.prefix;
        }
    }
};